import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import Footer from '../components/Footer';

function Contactdetails() {
    const { id } = useParams(); // Get the contact ID from URL
    const navigate = useNavigate();
    const [contact, setContact] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch specific contact data
    const fetchContactDetails = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await axiosInstance.get(`/contacts/details/${id}`);
            console.log("Contact details response:", response.data);
            setContact(response.data.data || response.data);
        } catch (error) {
            console.error("Error fetching contact details:", error);
            setError("Failed to fetch contact details");
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Failed to fetch contact details',
                confirmButtonText: 'Go Back'
            }).then(() => {
                navigate('/contact'); // Navigate back to contacts list
            });
        } finally {
            setLoading(false);
        }
    };

    // Delete Contact
    const handleDeleteContact = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                await axiosInstance.delete(`/contacts/${id}`);
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Contact has been deleted successfully.',
                    confirmButtonText: 'OK'
                }).then(() => {
                    navigate('/contact');
                });
            } catch (error) {
                console.error('Error deleting contact:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to delete contact',
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    // Get full name for display
    const getFullName = (contact) => {
        const firstName = contact?.first_name || '';
        const lastName = contact?.last_name || '';
        return `${firstName} ${lastName}`.trim() || 'N/A';
    };

    useEffect(() => {
        if (id) {
            fetchContactDetails();
        }
    }, [id]);

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !contact) {
        return (
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="alert alert-danger" role="alert">
                        {error || "Contact not found"}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content container-fluid">
                
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Contact Details</h5>
                            <div className="list-btn">
                                <ul className="filter-list">
                                    <li>
                                        <button 
                                            className="btn btn-secondary me-2"
                                            onClick={() => navigate('/contact')}
                                        >
                                            <i className="fa fa-arrow-left me-2"></i>Back to Contacts
                                        </button>
                                    </li>
                                    {contact.account && (
                                        <li>
                                            <button 
                                                className="btn btn-info me-2"
                                                onClick={() => navigate(`/account-details/${contact.account.id}`)}
                                            >
                                                <i className="fa fa-building me-2"></i>View Account
                                            </button>
                                        </li>
                                    )}
                                    <li>
                                        <button 
                                            className="btn btn-primary me-2"
                                            onClick={() => navigate('/Add-contact', { state: { contact, isEdit: true } })}
                                        >
                                            <i className="fa fa-edit me-2"></i>Edit Contact
                                        </button>
                                    </li>
                                    <li>
                                        <button 
                                            className="btn btn-danger"
                                            onClick={handleDeleteContact}
                                        >
                                            <i className="fa fa-trash me-2"></i>Delete Contact
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}

                    {/* Basic Contact Information */}
                    <div className="card customer-details-group">
                        <div className="card-header">
                            <h6 className="card-title mb-0">
                                <i className="fe fe-user me-2"></i>Personal Information
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="row align-items-center">					
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-user"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Full Name</h6>
                                                <p>{getFullName(contact)}</p>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-user"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>First Name</h6>
                                                <p>{contact.first_name || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-user"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Last Name</h6>
                                                <p>{contact.last_name || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-briefcase"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Designation</h6>
                                                <p>{contact.designation || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Information */}
                    <div className="card customer-details-group">
                        <div className="card-header">
                            <h6 className="card-title mb-0">
                                <i className="fe fe-phone me-2"></i>Contact Information
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-mail"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Email Address</h6>
                                                <p>
                                                    {contact.email ? (
                                                        <a href={`mailto:${contact.email}`} className="text-primary">
                                                            {contact.email}
                                                        </a>
                                                    ) : (
                                                        'N/A'
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-phone"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Primary Phone</h6>
                                                <p>
                                                    {contact.phone ? (
                                                        <a href={`tel:${contact.phone}`} className="text-primary">
                                                            {contact.phone}
                                                        </a>
                                                    ) : (
                                                        'N/A'
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-phone"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Alternate Phone</h6>
                                                <p>
                                                    {contact.alternate_phone ? (
                                                        <a href={`tel:${contact.alternate_phone}`} className="text-primary">
                                                            {contact.alternate_phone}
                                                        </a>
                                                    ) : (
                                                        'N/A'
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-message-square"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>WhatsApp Number</h6>
                                                <p>
                                                    {contact.whatsapp_no ? (
                                                        <a href={`https://wa.me/${contact.whatsapp_no.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                            {contact.whatsapp_no}
                                                        </a>
                                                    ) : (
                                                        'N/A'
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Account Information */}
                    {contact.account && (
                        <div className="card customer-details-group">
                            <div className="card-header">
                                <h6 className="card-title mb-0">
                                    <i className="fe fe-briefcase me-2"></i>Associated Account
                                </h6>
                            </div>
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                                        <div className="customer-details">
                                            <div className="d-flex align-items-center">
                                                <span className="customer-widget-icon d-inline-flex">
                                                    <i className="fe fe-briefcase"></i>
                                                </span>
                                                <div className="customer-details-cont">
                                                    <h6>Company Name</h6>
                                                    <p>
                                                        <span 
                                                            style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                                                            onClick={() => navigate(`/account-details/${contact.account.id}`)}
                                                            title="Click to view account details"
                                                        >
                                                            {contact.account.company_name}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                                        <div className="customer-details">
                                            <div className="d-flex align-items-center">
                                                <span className="customer-widget-icon d-inline-flex">
                                                    <i className="fe fe-layers"></i>
                                                </span>
                                                <div className="customer-details-cont">
                                                    <h6>Industry</h6>
                                                    <p>{contact.account.industry || 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                                        <div className="customer-details">
                                            <div className="d-flex align-items-center">
                                                <span className="customer-widget-icon d-inline-flex">
                                                    <i className="fe fe-globe"></i>
                                                </span>
                                                <div className="customer-details-cont">
                                                    <h6>Website</h6>
                                                    <p>
                                                        {contact.account.website ? (
                                                            <a 
                                                                href={contact.account.website.startsWith('http') ? contact.account.website : `https://${contact.account.website}`} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                className="text-primary"
                                                            >
                                                                {contact.account.website}
                                                            </a>
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Additional Information */}
                    <div className="card customer-details-group">
                        <div className="card-header">
                            <h6 className="card-title mb-0">
                                <i className="fe fe-info me-2"></i>Additional Information
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-activity"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Status</h6>
                                                <p>
                                                    <span className={`badge ${contact.isactive ? 'bg-success' : 'bg-danger'}`}>
                                                        {contact.isactive ? 'Active' : 'Inactive'}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-calendar"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Created Date</h6>
                                                <p>
                                                    {contact.created_at ? 
                                                        new Date(contact.created_at).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'long',
                                                            day: 'numeric'
                                                        }) : 'N/A'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                    <div className="customer-details">
                                        <div className="d-flex align-items-center">
                                            <span className="customer-widget-icon d-inline-flex">
                                                <i className="fe fe-edit"></i>
                                            </span>
                                            <div className="customer-details-cont">
                                                <h6>Last Updated</h6>
                                                <p>
                                                    {contact.updated_at ? 
                                                        new Date(contact.updated_at).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'long',
                                                            day: 'numeric'
                                                        }) : 'N/A'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Created By */}
                                {contact.createdBy && (
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                        <div className="customer-details">
                                            <div className="d-flex align-items-center">
                                                <span className="customer-widget-icon d-inline-flex">
                                                    <i className="fe fe-user-plus"></i>
                                                </span>
                                                <div className="customer-details-cont">
                                                    <h6>Created By</h6>
                                                    <p>{contact.createdBy.first_name} {contact.createdBy.last_name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Updated By */}
                                {contact.updatedBy && (
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                                        <div className="customer-details">
                                            <div className="d-flex align-items-center">
                                                <span className="customer-widget-icon d-inline-flex">
                                                    <i className="fe fe-user-check"></i>
                                                </span>
                                                <div className="customer-details-cont">
                                                    <h6>Updated By</h6>
                                                    <p>{contact.updatedBy.first_name} {contact.updatedBy.last_name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Notes */}
                                {contact.notes && (
                                    <div className="col-12">
                                        <div className="customer-details">
                                            <div className="d-flex align-items-start">
                                                <span className="customer-widget-icon d-inline-flex">
                                                    <i className="fe fe-file-text"></i>
                                                </span>
                                                <div className="customer-details-cont">
                                                    <h6>Notes</h6>
                                                    <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
                                                        {contact.notes}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Quick Actions Card */}
                    <div className="card">
                        <div className="card-header">
                            <h6 className="card-title mb-0">
                                <i className="fe fe-zap me-2"></i>Quick Actions
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 col-lg-3 mb-3">
                                    <div className="d-grid">
                                        <button 
                                            className="btn btn-outline-primary"
                                            onClick={() => contact.email && (window.location.href = `mailto:${contact.email}`)}
                                            disabled={!contact.email}
                                        >
                                            <i className="fe fe-mail me-2"></i>Send Email
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3 mb-3">
                                    <div className="d-grid">
                                        <button 
                                            className="btn btn-outline-success"
                                            onClick={() => contact.phone && (window.location.href = `tel:${contact.phone}`)}
                                            disabled={!contact.phone}
                                        >
                                            <i className="fe fe-phone me-2"></i>Call Contact
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3 mb-3">
                                    <div className="d-grid">
                                        <button 
                                            className="btn btn-outline-info"
                                            onClick={() => contact.whatsapp_no && window.open(`https://wa.me/${contact.whatsapp_no.replace(/[^0-9]/g, '')}`, '_blank')}
                                            disabled={!contact.whatsapp_no}
                                        >
                                            <i className="fe fe-message-square me-2"></i>WhatsApp
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3 mb-3">
                                    <div className="d-grid">
                                        <button 
                                            className="btn btn-outline-warning"
                                            onClick={() => navigate('/Add-contact', { state: { contact, isEdit: true } })}
                                        >
                                            <i className="fe fe-edit me-2"></i>Edit Contact
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default Contactdetails;